export class SignInRequest {
    constructor(
        public userName: string,
        public password: string
    ) { }
}
export class SignInRequestStoda {
    constructor(
        public userName?: string,
        public password?: string,
        public counter?: string,
        public ip?: string,
        public language?: string,
        public tuid?: string,
    ) { }
}
